import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetSelectedSpot } from 'store/spot/spot-actions';
import { userLogout } from 'store/user/user-actions';
import Navigation from '../../navigation';
import { Box } from '@spothero/ui';
import { tallHeaderStyles } from '../headerStyles';
import { expandedData, collapsedData } from '../constants';
import useConfig from 'hooks/use-config';
import { useHeaderKey } from 'pages/search/hooks/use-header-key';
import { useElementHeight } from 'hooks/use-element-height';
const HeaderMobile = () => {
    const [headerRef] = useElementHeight();
    const key = useHeaderKey();
    const { isProduction } = useConfig();
    const dispatch = useDispatch();
    const { data: user } = useSelector((state) => state.user);
    const clearSelectedSpot = () => {
        dispatch(resetSelectedSpot());
    };
    const onUserLogout = () => {
        dispatch(userLogout());
    };
    return (<Box ref={headerRef} {...tallHeaderStyles} as="header" role="banner" data-testid="Header" key={key}>
            <Navigation 
    // @ts-expect-error Redux compose Typing mismatch
    isProduction={isProduction} user={user} collapsedData={collapsedData} expandedData={expandedData} onItemSelected={clearSelectedSpot} onUserLogout={onUserLogout}/>
        </Box>);
};
export default HeaderMobile;
